export default "__VITE_ASSET__557a52ea__"